export var VERSION = '2.1.3';
//# sourceMappingURL=version.js.map